import React from "react";
import styled from 'styled-components';

const AttributionContainer = styled.div`
  &:hover {
    cursor: pointer
  }
`;
const AttributionText = styled.span`
  color: blue;
`;

export default props => {
  return (
    <AttributionContainer id="attribution-placeholder">
      Sayers and Partners
    </AttributionContainer>
  );
}